import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsPOIListViewedParams = {
  num_pois?: number;
  trail_id: number;
};

/**
 * User views the POI list section of the trail page. This will be fired when the POI list section goes into view not when the section is 100% visible.
 * @param params - Attributes to log with the amplitude event
 * @param params.num_pois - The number of POIs in the list
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsPOIListViewed = ({ num_pois, trail_id }: logTrailDetailsPOIListViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details poi list viewed', { 'num pois': num_pois, 'trail id': trail_id }, callback);
};

export default logTrailDetailsPOIListViewed;
